import React from "react";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation("global");

  return (
    <main className="content-wrapper">
      {/* عنوان وترحيب الصفحة */}
      <section className="container pt-5 mt-1 mt-sm-2 mt-md-4 mt-lg-5">
        <div
          className="text-center pb-2 pb-sm-3 pb-lg-0 pb-xxl-2 mx-auto mb-4 mb-lg-5"
          style={{
            maxWidth: "650px",
          }}
        >
          <h1 className="text-body fs-xs fw-medium text-uppercase mb-sm-4">
            مرحباً بكم في روز باريس للعطور
          </h1>
          <h2 className="h1 mb-0">
            نؤمن بأن العطر المثالي يعبر عن شخصية كل فرد، اكتشفوا مجموعتنا
            الراقية
          </h2>
        </div>
      </section>

      {/* مميزات الشركة */}
      <section className="container pt-5 mt-1 mt-sm-3 mt-md-4 mt-lg-5 mb-4">
        <div className="row row-cols-1 row-cols-md-3 gy-3 gy-sm-4 gx-2 gx-lg-4">
          <div className="col text-center">
            <svg
              className="d-block text-dark-emphasis mx-auto mb-3 mb-lg-4"
              fill="currentColor"
              height="64"
              viewBox="0 0 64 64"
              width="64"
              xmlns="http://www.w3.org/2000/svg"
            ></svg>
            <h3 className="h5">تشكيلة متنوعة</h3>
            <p className="fs-sm px-5 mb-md-0">
              اكتشفوا مجموعة واسعة من العطور الفاخرة التي تناسب جميع الأذواق
              والمناسبات.
            </p>
          </div>
          <div className="col text-center">
            <svg
              className="d-block text-dark-emphasis mx-auto mb-3 mb-lg-4"
              fill="currentColor"
              height="64"
              viewBox="0 0 64 64"
              width="64"
              xmlns="http://www.w3.org/2000/svg"
            ></svg>
            <h3 className="h5">جودة عالية</h3>
            <p className="fs-sm px-5 mb-md-0">
              نستخدم أفضل المكونات الطبيعية لنقدم عطوراً ذات ثبات وجودة
              استثنائية.
            </p>
          </div>
          <div className="col text-center">
            <svg
              className="d-block text-dark-emphasis mx-auto mb-3 mb-lg-4"
              fill="currentColor"
              height="64"
              viewBox="0 0 64 64"
              width="64"
              xmlns="http://www.w3.org/2000/svg"
            ></svg>
            <h3 className="h5">تجربة فاخرة</h3>
            <p className="fs-sm px-5 mb-md-0">
              استمتعوا بتجربة تسوق مميزة مع خدمة توصيل سريعة وعناية شخصية.
            </p>
          </div>
        </div>
      </section>

      {/* قسم المزايا التفصيلية */}
      <section className="bg-dark py-5 mt-n2 mt-sm-0" data-bs-theme="dark">
        <div className="container pt-1 pt-sm-2 pt-md-3 pb-md-2 pt-lg-4 pb-lg-3 pb-xl-4 pt-xl-5 pb-xxl-5 mt-xxl-3">
          <div className="row">
            <div className="col-lg-3 d-flex flex-column flex-sm-row flex-lg-column align-items-center align-items-lg-start pb-3 mb-3 mb-md-4">
              <h2 className="h1 text-center text-sm-start mb-sm-0 mb-lg-5 me-sm-4 me-lg-0">
                ثلاث مزايا مميزة
              </h2>
              <a className="btn btn-lg btn-outline-light rounded-pill ms-sm-auto ms-lg-0">
                عرض المجموعة
              </a>
            </div>
            <div className="col-lg-9">
              <div className="overflow-auto" data-simplebar="">
                <div className="d-flex gap-4">
                  <div
                    className="w-100"
                    style={{
                      minWidth: "230px",
                    }}
                  >
                    <img
                      alt="عطر 1"
                      className="d-block rounded-4 mb-4"
                      src="/assets/img/about/v2/perfume01.jpg"
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                      }}
                    />
                    <h3 className="h5 pb-1 mb-2">تشكيلة متنوعة</h3>
                    <p className="text-body fs-sm mb-4">
                      مجموعة فاخرة من العطور المميزة التي تناسب جميع الأذواق.
                    </p>
                  </div>
                  <div
                    className="w-100"
                    style={{
                      minWidth: "230px",
                    }}
                  >
                    <img
                      alt="عطر 2"
                      className="d-block rounded-4 mb-4"
                      src="/assets/img/about/v2/perfume02.jpg"
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                      }}
                    />
                    <h3 className="h5 pb-1 mb-2">جودة عالية</h3>
                    <p className="text-body fs-sm mb-4">
                      نختار المكونات الطبيعية بعناية لنقدم عطوراً ذات ثبات وجودة
                      لا تضاهى.
                    </p>
                  </div>
                  <div
                    className="w-100"
                    style={{
                      minWidth: "230px",
                    }}
                  >
                    <img
                      alt="عطر 3"
                      className="d-block rounded-4 mb-4"
                      src="/assets/img/about/v2/perfume03.jpg"
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                      }}
                    />
                    <h3 className="h5 pb-1 mb-2">تجربة فاخرة</h3>
                    <p className="text-body fs-sm mb-4">
                      استمتعوا بخدمة توصيل سريعة وتجربة تسوق فريدة لعطوركم
                      المفضلة.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* قسم الموقع والتواصل */}
      <section className="container pt-1 pt-sm-2 pt-md-3 mb-4 pt-lg-4 pt-xl-5 mt-xxl-3">
        <div className="row row-cols-1 row-cols-md-2 g-0 overflow-hidden rounded-5 mt-5">
          <div className="col position-relative">
            <div className="ratio ratio-4x3" />
            <img
              alt="عطر - فيديو"
              className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
              src="/assets/img/about/v2/perfume03.jpg"
            />
            <div className="position-absolute start-0 bottom-0 d-flex align-items-end w-100 h-100 z-2 p-4">
              <a
                className="btn btn-lg btn-light rounded-pill m-md-2"
                data-gallery="map"
                data-glightbox="width: 100vw; height: 100vh;"
                href="https://maps.app.goo.gl/roseparis"
              >
                <i className="ci-map fs-lg ms-n1 me-2" />
                عرض على الخريطة
              </a>
            </div>
          </div>
          <div className="col bg-body-tertiary order-md-1 py-5 px-4 px-xl-5">
            <div className="py-md-4 py-lg-5 px-md-4 px-lg-5">
              <h1 className="pb-2 pb-sm-3 pb-lg-0 mb-md-4 mb-lg-5">موقعنا</h1>
              <ul className="list-unstyled pb-sm-2 mb-0">
                <li className="d-flex">
                  <i className="ci-map-pin fs-lg mt-1" />
                  <span className="ps-2 ms-1">
                    تكريت / شارع زيونة <br />
                  </span>
                </li>
                <li className="nav animate-underline">
                  <i className="ci-phone fs-lg mt-1 pe-2 me-1" />
                  <a
                    className="nav-link animate-target fs-base fw-normal p-0"
                    href="tel:+9647748999948"
                  >
                    +964 774 899 9948
                  </a>
                </li>
                <li className="nav animate-underline">
                  <i className="ci-mail fs-lg mt-1 pe-2 me-1" />
                  <a
                    className="nav-link animate-target fs-base fw-normal p-0"
                    href="mailto:info@rusepares.com"
                  >
                    info@rusepares.com
                  </a>
                </li>
              </ul>
              <hr />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
